module.exports = __webpack_public_path__ + "static/scale-model-of-laredo-texas-e68092a70f0cb81e2a37e1d297960efb.png";